
/*
 *  Copyright (c) 2024 - SimpliCity Digital Inc - All Rights Reserved
 */

/**
 *  handleJSON
 *  @param {string} str
 */
export const handleJSON = async function (str) {
    if (isJsonString(str)) {
        try {
            const temp = JSON.parse(str)
            return JSON.stringify(temp)
        } catch (e) { throw e }
    }
    return JSON.stringify(str)
}

/**
 *  isJsonString
 *  @param {string} str
 */
export const isJsonString = function(str) {
    try { JSON.parse(str) } catch (e) { return false }
    return true;
}
